import React, { useEffect, useState, useRef, Dispatch, SetStateAction } from "react";
import { IconCloseCircle, IconDownChevron } from "@util/assets";
import { HeaderNavMobileWrapper, NavLevelTwoItemsWrapper } from "./headerNavMobile.style";
import { SanityHeader, Maybe, SanityLinkOrMegaNav, SanityMegaNav } from "@graphql-types";
import { SearchField, Link } from "@global";
import { TopRegionDropdown } from "./topHeader";
import { isSanityMegaNav } from "@util/types"
import { globalHistory } from '@reach/router'

interface Props {
  data: SanityHeader;
  openMobileState: any;
}

function HeaderNavMobile({ data, openMobileState }: Props) {
  const { openMobileNav, setOpenMobileNav } = openMobileState;
  const { links } = data;

  useEffect(() => {
    document.body.style.overflow = openMobileNav ? `hidden` : `initial`;
  }, [openMobileNav]);

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') {
        setOpenMobileNav(false)
      }
    })
  })

  const refHeaderWrapper = useRef<HTMLDivElement>(null);


  return (
    <HeaderNavMobileWrapper active={openMobileNav} ref={refHeaderWrapper}>
      <div className="inner">
        <div className="intro">
          <div className="top-wrapper">
            <IconCloseCircle onClick={() => setOpenMobileNav(!openMobileNav)} />
            <TopRegionDropdown />
          </div>
          <SearchField design="solid" />
        </div>
        <nav>
          {links && links.map(levelOneLinks => <NavLevelOneItems data={levelOneLinks} key={levelOneLinks?._key} refHeader={refHeaderWrapper.current} />)}
        </nav>
      </div>
    </HeaderNavMobileWrapper>
  );
}

export default HeaderNavMobile;

interface NavLevelOneItemsProps {
  data: Maybe<SanityLinkOrMegaNav>;
  refHeader: HTMLDivElement | null;
}

function NavLevelOneItems({ data, refHeader }: NavLevelOneItemsProps) {
  const [levelTwoOpen, setLevelTwoOpen] = useState(false);

  if (data == null) return null;
  const { linkText } = data;

  useEffect(() => {
    if (levelTwoOpen && refHeader) {
      refHeader.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }, [levelTwoOpen])

  return (<li>
    {!isSanityMegaNav(data) && <Link {...data} className="mob-card-button mob-card-button--no-dropdown" />}
    {isSanityMegaNav(data) && (<>
      <a tabIndex={0} role="button" onClick={() => setLevelTwoOpen(!levelTwoOpen)} className="mob-card-button">
        <span>{linkText}</span>
        <IconDownChevron />
      </a>
      <NavLevelTwoItems data={data} state={[levelTwoOpen, setLevelTwoOpen]} />
    </>
    )}
  </li>)

}

interface NavLevelTwoItemProps {
  data: SanityMegaNav;
  state: [boolean, Dispatch<SetStateAction<boolean>>];
}

function NavLevelTwoItems({ data, state }: NavLevelTwoItemProps) {
  const [levelTwoOpen, setLevelTwoOpen] = state;
  const { design, dropDown, dropDownPlain, linkText } = data;
  const dropDownContent = (design === `designPlain` && dropDownPlain) || (design === `designBrand` && dropDown);

  return (
    <NavLevelTwoItemsWrapper status={levelTwoOpen}>
      <a tabIndex={0} role="button" onClick={() => setLevelTwoOpen(!levelTwoOpen)} className="mob-card-button">
        <span>{linkText}</span>
        <IconDownChevron />
      </a>

      {dropDownContent && <ul>
        {dropDownContent.map(link => <li key={link?._key}><Link {...link} /></li>)}
      </ul>}
    </NavLevelTwoItemsWrapper>
  )
}